import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import SafeAnchor from '../bootstrap/SafeAnchor.js';
import { bsClass, getClassSet, splitBsProps } from '../bootstrap/utils/bootstrapUtils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class Thumbnail extends React.Component {
  render() {
    const {
      src,
      alt,
      onError,
      onLoad,
      className,
      children,
      ...props
    } = this.props;
    const [bsProps, elementProps] = splitBsProps(props);
    const Component = elementProps.href ? SafeAnchor : 'div';
    const classes = getClassSet(bsProps);
    return /*#__PURE__*/_jsxs(Component, {
      ...elementProps,
      className: clsx(className, classes),
      children: [/*#__PURE__*/_jsx("img", {
        src,
        alt,
        onError,
        onLoad
      }), children && /*#__PURE__*/_jsx("div", {
        className: "caption",
        children: children
      })]
    });
  }
}
export default bsClass('thumbnail', Thumbnail);